/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { queryClient } from '@lib/react-query';

// Components
import { notifications } from '@mantine/notifications';

// Types
import { IApiError } from '@global-types/index';
import { TMeterPoint } from '../types';

// I18n
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */

export const remove = (
	id: string
): Promise<TMeterPoint> => {
	return apiClient.delete(`/meter_points/${id} `);
};

export const useRemove = (page: number, size: number) => {
	const { t } = useTranslation();
	const { mutate, isPending: isLoading } = useMutation({
		mutationFn: remove,
		onSuccess: () => {
			notifications.show({
				title: t('global.success'),
				message: t(
					'meterPoints.notifications.meterPointSuccessfullyDeleted'
				),
				color: 'success',
			});
			queryClient.invalidateQueries({
				queryKey: [
					'meter-points-projects',
					{ page: page, size: size },
				],
			});
		},
		onError: (error: IApiError) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading };
};
